import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "components/ui/DataTable";
import { IDataTableAction, DataTableActions } from "components/ui/DataTableActions";
import { Carrier } from "contracts/Carrier";
import { CarrierMember } from "contracts/CarrierMembers";
import { usePermission } from "hooks/usePermission";
import { Formatter } from "utils";

export function useColumns(){

    const { hasPermissionTo } = usePermission()

    const columns: ColumnDef<CarrierMember>[] = [
        {
            id: 'Id',
            accessorKey: 'id',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Id" />
            ),
            cell: ({ row }) => {
                return `${row.original.id}`
            },
            enableSorting: true,
            enableHiding: true,
        },
         {
            id: 'Nome',
            accessorKey: 'name',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Nome" />
            ),
            cell: ({ row }) => {
                return `${row.original.name ?? "---"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'Email',
            accessorKey: 'email',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="e-mail" />
            ),
            cell: ({ row }) => {
                return `${row.original.email ?? "---"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'Transportadora',
            accessorKey: 'carrier',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Transportadora" />
            ),
            cell: ({ row }) => {
                return `${row.original.carrierMember.map((c: Carrier) => c.tradeName).join(', ') ?? "---"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'LastAccess',
            accessorKey: 'lastAccess',
            header: ({column}) => (
                <DataTableColumnHeader column={column} title="Último Acesso" />
            ),
            cell: ({ row }) => {
                return `${Formatter.date(row.original?.loggedAt, { format: "dd/MM/yyyy 'as' HH:mm" }) ?? "--/--/----"}`
            },
            enableSorting: true,
            enableHiding: true,
        },
        {
            id: 'actions',
            cell: ({ row }) => {
                const actions: IDataTableAction[] = [
                    {
                        name: 'Editar',
                        route: `/configuracoes/usuarios/editar/${row.original.id}`,
                        hasPermission: hasPermissionTo(['CARRIER-MEMBERS.UPDATEMEMBER']),
                    },
                    // {
                    //     name: 'Logar como',
                    //     route: `/configuracoes/usuarios/impersonate/${row.original.email}`,
                    //     hasPermission: row.original.carrierMember.length > 0 && hasPermissionTo(['AUTH.IMPERSONATE'])
                    // }
                ];
                return <DataTableActions actions={actions} />;
            },
        },
    ]

    return { columns }
}